import { useRef } from 'react'
import { ReactComponent as LogoSVG } from '../../assets/logo.svg'
import Button from '../Button'
import { ButtonProps } from '../Button/index.types'
import styles from './styles.module.css'
import img from '../../assets/favicon.png'

export default function RectangularButtons() {
  const logoRef = useRef<SVGSVGElement>(null)

  const buttons: ButtonProps[] = [
    { label: 'ACADEMIA DE TRADING Y FINANZAS', style: 1, position: { top: '25%', left: '21%' }, icon: 'FaGraduationCap', iconPosition: 'right', textPosition: 'right', link: 'https://seagreen-anteater-211196.hostingersite.com/academia/' }, //ok
    { label: 'BLOG DE ANÁLISIS DE MERCADO', style: 2, position: { top: '43%', left: '16%' }, icon: 'FaChartLine', iconPosition: 'right', textPosition: 'right', link: 'https://seagreen-anteater-211196.hostingersite.com/blug/' }, // ok
    { label: 'GESTIÓN DE CAPITALES', style: 1, position: { top: '60%', left: '21%' }, icon: 'FaPiggyBank', iconPosition: 'right', textPosition: 'right', link: 'https://seagreen-anteater-211196.hostingersite.com/elementor-256/' },
    { label: 'ASESORAMIENTO JURÍDICO', style: 2, position: { top: '72%', left: '35%' }, icon: 'FaBalanceScale', iconPosition: 'right', textPosition: 'right', link: 'https://seagreen-anteater-211196.hostingersite.com/gestion-de-capitales/' }, // ok
    { label: 'ESTUDIO DE MERCADO GRAFICACIÓN', style: 1, position: { top: '72%', left: '51%' }, icon: 'FaChartBar', iconPosition: 'left', textPosition: 'left', link: 'https://seagreen-anteater-211196.hostingersite.com/estudio-del-mercado/' }, // ok
    { label: 'FORMACIÓN ENSEÑANZA', style: 2, position: { top: '60%', left: '68%' }, icon: 'FaChalkboardTeacher', iconPosition: 'left', textPosition: 'left', link: 'https://seagreen-anteater-211196.hostingersite.com/formacion/' }, // ok
    { label: 'ASESORAMIENTO FINANCIERO', style: 2, position: { top: '43%', left: '72%' }, icon: 'FaHandHoldingUsd', iconPosition: 'left', textPosition: 'left', link: 'https://seagreen-anteater-211196.hostingersite.com/asesoramiento/' }, // ok
    { label: 'BROKER', style: 1, position: { top: '25%', left: '68%' }, icon: 'FaUserTie', iconPosition: 'left', textPosition: 'left', link: 'https://innovafxcapital.com/' },
    { label: 'OPERATIVA EN TIEMPO REAL', style: 1, position: { top: '19%', left: '44%' }, icon: 'FaStopwatch', iconPosition: 'left', textPosition: 'left', link: 'https://innovafxcapital.com/' },
  ]

  return (
    <div className={styles.container}>
      <div>
        <a href="https://seagreen-anteater-211196.hostingersite.com/" target="_blank" rel="noopener noreferrer">
          <img
            src={img}
            alt="Descripción de la imagen"
            style={{
              width: '4%',
              height: '4%',
              position: 'absolute',
              zIndex: 99,
              right: '5%',
              top: '2%',
              transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.1)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)'
            }}
          />
        </a>
        <button
          style={{
            width: '10%',
            height: '4%',
            position: 'absolute',
            zIndex: 99,
            right: '2%',
            top: '8%',
            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
            borderRadius: '10px',
            borderWidth: '0px',
            cursor: 'pointer',
          }}
          onClick={() => (window.location.href = 'https://seagreen-anteater-211196.hostingersite.com/')}
        >
          Ir a página ppal
        </button>
      </div>
      <div onClick={() => (window.location.href = 'https://seagreen-anteater-211196.hostingersite.com/espacio-trading/')} className={styles.logoCenter} style={{ cursor: 'pointer' }}>
        <LogoSVG ref={logoRef} className={styles.logoSVG} />
      </div>
      <div onClick={() => (window.location.href = 'https://seagreen-anteater-211196.hostingersite.com/espacio-trading/')} className={`${styles.logoCenter} ${styles.transparentLogo}`} style={{ cursor: 'pointer' }}></div>

      <svg className={styles.lines}>
        <rect x="25%" y="25%" width="50%" height="50%" fill="none" stroke="black" strokeWidth="2" rx="15%" />
      </svg>

      {buttons.map((button, index) => (
        <div
          key={index}
          className={styles.circle}
          style={{
            position: 'absolute',
            top: button.position?.top,
            left: button.position?.left,
          }}
        >
          <Button label={button.label} style={button.style} icon={button.icon} iconPosition={button.iconPosition} textPosition={button.textPosition} link={button.link} />
        </div>
      ))}
    </div>
  )
}
